<div class="containerMarginX">
  <tech-simulation-data-init
    [simulationData]="form.get('simulationData')"
  ></tech-simulation-data-init>
  <div
    class="flex-container-nowrap mt-4 mb-50 flex-container-end flex-sm-content-center"
  >
    <button
      type="button"
      class="buttonPortal lg mr-2"
      mat-raised-button
      (click)="goNext()"
      [disabled]="form.invalid || errorMinimun"
    >
      <span>{{ 'k000226' | translate }}</span>
      <!-- Token: Continue -->
    </button>
  </div>
</div>
